<div 
    *ngIf="functionDetails"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeModal();"
>
    <div class="w-full max-w-screen-md max-h-[90%] flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <div class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row items-start justify-between gap-2">
                    <h2 class="min-w-0 flex-1 oswald-font text-xl font-medium text-start whitespace-pre-line break-words [overflow-wrap:anywhere]">
                        Function:
                        <span class="text-nside-orange-400">{{ functionDetails?.function_name }}</span>
                    </h2>
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeModal();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full h-full overflow-y-auto">
                    <table class="w-full text-left">
                        <thead class="oswald-font font-medium text-lg uppercas">
                            <tr class="border-b border-gray-200">
                                <th scope="col" class="px-6 py-3 bg-gray-50">
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Goal
                                </th>
                                <th scope="col" class="px-6 py-3 bg-gray-50">
                                    Objectives
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-b border-gray-200">
                                <th scope="row" class="px-6 py-4 bg-gray-50">
                                    Before
                                </th>
                                <td class="max-w-72 px-6 py-4 whitespace-pre-line break-words">
                                    {{ functionDetails?.goals?.[0]?.goal_description }}
                                </td>
                                <td class="max-w-72 px-6 py-4 bg-gray-50 whitespace-pre-line break-words">
                                    {{ functionDetails?.goals?.[0]?.objective }}
                                </td>
                            </tr>
                            <tr class="border-b border-gray-200">
                                <th scope="row" class="px-6 py-4 bg-gray-50">
                                    During
                                </th>
                                <td class="max-w-72 px-6 py-4 whitespace-pre-line break-words">
                                    {{ functionDetails?.goals?.[1]?.goal_description }}
                                </td>
                                <td class="max-w-72 px-6 py-4 bg-gray-50 whitespace-pre-line break-words">
                                    {{ functionDetails?.goals?.[1]?.objective }}
                                </td>
                            </tr>
                            <tr class="border-b border-gray-200">
                                <th scope="row" class="px-6 py-4 bg-gray-50">
                                    After
                                </th>
                                <td class="max-w-72 px-6 py-4 whitespace-pre-line break-words">
                                    {{ functionDetails?.goals?.[2]?.goal_description }}
                                </td>
                                <td class="max-w-72 px-6 py-4 bg-gray-50 whitespace-pre-line break-words">
                                    {{ functionDetails?.goals?.[2]?.objective }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="w-full flex flex-row gap-2 items-center justify-between">
                    <div class="min-w-10 flex gap-1 items-start justify-center">
                        <p class="oswald-font font-normal">
                            Last Updated At: <span class="raleway-font">{{ functionDetails?.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span>
                        </p>
                        <p class="oswald-font font-normal">
                            By: <span class="raleway-font">{{ functionDetails?.last_updated_user_name || 'None' }}</span>
                        </p>
                    </div>
                    <button 
                        (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</div>